import { useState } from "react";

const CATEGORIES = ["Nails", "Facials", "Tanning", "Makeup", "Hair", "Add-on"];

/**
 * Inline form to add a new service to the menu. Calls onAdd(svc) which returns
 * true on success — parent clears + dismisses the form.
 */
export default function AddServiceForm({ onAdd, onCancel }) {
    const [svc, setSvc] = useState({
        service_id: "", name: "", category: "Nails", price: "", duration_min: 60,
    });

    const submit = async () => {
        const ok = await onAdd(svc);
        if (ok) {
            setSvc({ service_id: "", name: "", category: "Nails", price: "", duration_min: 60 });
            onCancel();
        }
    };

    return (
        <div className="mb-8 rounded-2xl border border-gold/40 bg-gold/5 p-6">
            <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4">New service</p>
            <div className="grid sm:grid-cols-5 gap-3">
                <input
                    placeholder="service_id (lowercase_with_underscores)"
                    value={svc.service_id}
                    onChange={(e) => setSvc({ ...svc, service_id: e.target.value })}
                    className="sm:col-span-2 bg-ink/40 border border-white/15 focus:border-gold/50 rounded-lg px-3 py-2 outline-none text-sm"
                />
                <select
                    value={svc.category}
                    onChange={(e) => setSvc({ ...svc, category: e.target.value })}
                    className="bg-ink/40 border border-white/15 focus:border-gold/50 rounded-lg px-3 py-2 outline-none text-sm"
                >
                    {CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
                <input
                    type="number" placeholder="Price"
                    value={svc.price}
                    onChange={(e) => setSvc({ ...svc, price: e.target.value })}
                    className="bg-ink/40 border border-white/15 focus:border-gold/50 rounded-lg px-3 py-2 outline-none text-sm"
                />
                <input
                    type="number" placeholder="Minutes"
                    value={svc.duration_min}
                    onChange={(e) => setSvc({ ...svc, duration_min: e.target.value })}
                    className="bg-ink/40 border border-white/15 focus:border-gold/50 rounded-lg px-3 py-2 outline-none text-sm"
                />
            </div>
            <input
                placeholder="Display name (e.g. 'Manicure — Classic')"
                value={svc.name}
                onChange={(e) => setSvc({ ...svc, name: e.target.value })}
                className="mt-3 w-full bg-ink/40 border border-white/15 focus:border-gold/50 rounded-lg px-3 py-2 outline-none text-sm"
            />
            <div className="mt-4 flex gap-3">
                <button onClick={submit} className="px-5 py-2 rounded-full bg-gold text-ink font-medium text-sm hover:opacity-90 transition">
                    Add to menu
                </button>
                <button onClick={onCancel} className="px-5 py-2 rounded-full border border-white/15 text-white/70 text-sm hover:text-white hover:border-white/30 transition">
                    Cancel
                </button>
            </div>
        </div>
    );
}
